import { motion } from "framer-motion";

export const EASE = [0.76, 0, 0.24, 1];

export const LineReveal = ({ lines, className = "", delay = 0, as = "h1", testid, inView = false }) => {
  const Tag = motion[as];
  const anim = inView
    ? { initial: "hide", whileInView: "show", viewport: { once: true, amount: 0.15 } }
    : { initial: "hide", animate: "show" };
  return (
    <Tag className={className} data-testid={testid} {...anim}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.14em] -mb-[0.14em]">
          <motion.span
            className="block"
            variants={{ hide: { y: "112%", rotate: 2 }, show: { y: "0%", rotate: 0 } }}
            transition={{ duration: 1.15, ease: EASE, delay: delay + i * 0.11 }}
          >
            {l}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const Reveal = ({ children, className = "", delay = 0, y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 1, ease: [0.22, 1, 0.36, 1], delay }}
  >
    {children}
  </motion.div>
);
